"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Icon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.92 25.91H19.08a11.58 11.58 0 00-4.24 22.35v23a2.5 2.5 0 002.5 2.5h65.32a2.5 2.5 0 002.5-2.5v-23a11.58 11.58 0 00-4.24-22.35zm-63.1 18a6.58 6.58 0 011.26-13h30.21a6.58 6.58 0 011.26 13 2.5 2.5 0 00-2 2.45v22.4H19.84V46.39a2.5 2.5 0 00-2.02-2.45zm64.36 0a2.5 2.5 0 00-2 2.45v22.4H53.52v-20.5a11.59 11.59 0 007.34-10.77 11.47 11.47 0 00-2.06-6.58h22.12a6.58 6.58 0 011.26 13z",
    className: "cls-1"
  })));
}

var _default = Icon;
exports["default"] = _default;